<template>
  <v-card flat>
    <v-container fluid grid-list-md fill-height style="padding:0px;width:100%;height:100vh;">
      <v-layout row fill-height>
        <v-flex d-flex md6>
          <v-layout column style="height: 100vh;">
            <img width="280" :src="require('../assets/WiDE_Logo_Dark.png')" alt="" style="margin-left: 16px">
            <v-flex d-flex md4>
              <v-card flat style="margin-right:100px;">
                <v-card-title>
                  <v-layout column>
                    <div class="header">WiDE - WinGD Integrated Digital Expert</div>
                    <div class="sub-header">Creating value from engine and ship data</div>
                  </v-layout>
                </v-card-title>
                <v-card-text fluid style="padding-bottom: 0; height: 30rem; max-height: 30rem;">
                  <v-container fill-height grid-list-md style="padding-bottom: 0; height: 100%">
                    <v-layout column>
                      <v-flex md4 style="max-height: calc(100% / 12 * 2)">
                        <v-text-field
                            ref="email_inp"
                            v-model="email"
                            label="Email"
                            v-on:keyup.enter="submitInput"
                        />
                      </v-flex>
                      <v-flex md4 style="max-height: calc(100% / 12 * 2)">
                        <v-text-field
                            ref="pass_inp"
                            v-model="password"
                            :append-icon="((show) ? 'visibility' : 'visibility_off')"
                            :type="show ? 'text' : 'password'"
                            label="Password"
                            v-on:keyup.enter="submitInput"
                            @click:append="show = !show"
                        />
                      </v-flex>
                      <v-flex md4 style="max-height: calc(100% / 12 * 3)">
                        <v-btn style="color:white; background-color: rgb(51,82,128); width: 100%; margin-left: 0;" flat @click="userLogin()">Login</v-btn>
                      </v-flex>
                      <v-flex md4 style="max-height: calc(100% / 12 * 2)">
                        <div style="height: 1rem;display: flex;flex-grow: 1;flex-direction: column;width: 100%;position: relative;justify-content: center;align-items: center;">
                          <hr style="width: 100%;">
                          <div id="loginInfoHolder">
                            or login with
                            <v-tooltip bottom color="white">
                              <template v-slot:activator="{ on, attrs }">
                                <font-awesome-icon
                                    icon="info"
                                    v-bind="attrs"
                                    v-on="on"
                                />
                              </template>
                              <span style="color: black"><pre style="font-family: inherit;" v-html="cognito_msg" /></span>
                            </v-tooltip>
                          </div>
                        </div>
                        <v-btn style="color:white; background-color: rgb(51,82,128); width: 100%; margin-left: 0;" flat @click="cognitoLogin()">Other Identity Provider</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-alert class='alert' :value="alert" type="error" transition="scale-transition" color='rgb(205, 57, 64)' outline dismissible @input="closeAlert">
                  {{ ((customAlert == '') ? 'The email and password you entered are not correct.' : customAlert) }}
                </v-alert>
              </v-card>
            </v-flex>
            <v-alert
                outline
                dismissible
                class='alert'
                :value="alert"
                type="error"
                transition="scale-transition"
                color='rgb(205, 57, 64)'
                style="margin: auto; position: absolute;"
                @input="closeAlert"
            >
              {{ logout_msg || "The email and password you entered are not correct" }}
            </v-alert>
          </v-layout>

        </v-flex>
        <v-flex d-flex md6 style="padding: 0;">
          <img :src="require('../assets/EDS online login page.png')" style="width:100%;height:100%;" alt="">
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import axios from 'axios'
import {store} from "../main.js"

export default {
  name: "Login",
  components: {},
  data() {
    return {
      email: '',
      password: '',
      show: false,
      alert: false,
      profile: {},
      customAlert: '',
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    closeAlert(v) {
      this.alert = false;
      localStorage.setItem('wingd_users_logout_msg', '');
      store.logout_msg = '';
    },
    userLogin() {
      if (this.password.length <= 0) {
        this.alert = true;
      } else {
        axios.post(store.config.api_location + '/login', {email: this.email, password: this.password, wingd_user: true}, {withCredentials: true})
            .then(
                (response) => {
                  if (response.status === 200) {
                    localStorage.setItem('cognito_code', null);

                    if (response.status === 200) {
                      store.userProfile = response.data;
                      store.userLogged = true;

                      window.$cookies.set('user', response.data);

                      store.MyEvent.fire('logged_in');

                      if (store.requestedBeforeLogin.length) {
                        this.$router.push((new URL(store.requestedBeforeLogin)).pathname.toString())
                      } else {
                        this.$router.push({path: 'engines'});
                      }
                    } else {
                      this.alert = true;
                    }
                  } else {
                    this.alert = true;
                  }
                },
                (error) => {
                  this.alert = true;
                }
            );
      }
    },
    cognitoLogin() {
      location = `${store.config.api_location}/cognito`
    },
    loginWithCognitoCode() {
      let params = {withCredentials: false};

      axios.post(store.config.api_location + '/cognito_login', {cognito_code: localStorage.cognito_code}, params)
          .then(
              async (response) => {
                localStorage.setItem('cognito_code', null);

                if (response.status === 200) {
                  store.userProfile = response.data;
                  store.userLogged = true;

                  window.$cookies.set('user', response.data);

                  store.MyEvent.fire('logged_in');

                  if (store.requestedBeforeLogin.length) {
                    this.$router.push((new URL(store.requestedBeforeLogin)).pathname.toString())
                  } else {
                    this.$router.push({path: 'engines'});
                  }
                } else {
                  this.alert = true;
                }
              },
              (error) => {
                localStorage.setItem('cognito_code', null);

                if (error.response.data.error == 'Cognito user not found') {
                  this.$refs['alertTextDisplay'].innerHTML = this.cognito_msg;
                } else {
                  this.customAlert = error.response.data.error;
                }
                this.alert = true;
              }
          );
    },
    redirectToProvider() {
      let provider = localStorage.requested_provider;
      localStorage.setItem('requested_provider', null);
      location = `${store.config.api_location}/identity_providers/redirect_to/${provider}`
    },
    handleLoginError() {
      let login_error = localStorage.login_error;
      localStorage.setItem('login_error', null);

      this.customAlert = login_error;
      this.alert = true;
    }
  },
  computed: {
    logout_msg: () => {
      return store.logout_msg;
    },
    api_location: function () {
      return store.config.api_location;
    }
  },
  watch: {
    logout_msg: function (value) {
      this.alert = (store.logout_msg || '').length > 0;
    },
    api_location: function (location) {
      if (!!location && typeof location != 'undefined') {
        if (!window.$cookies.isKey('user') && !!localStorage.cognito_code && localStorage.cognito_code != 'null') {
          this.loginWithCognitoCode()
        } else if (!window.$cookies.isKey('user') && !!localStorage.requested_provider && localStorage.requested_provider != 'null') {
          this.redirectToProvider()
        } else if (!window.$cookies.isKey('user') && !!localStorage.login_error && localStorage.login_error != 'null') {
          this.handleLoginError()
        }
      }
    }
  }
}

</script>

<style scoped>
.action-btn {
  color: white !important;
  background-color: rgb(51, 82, 128);
  width: 100%;
  margin-left: 0;
}

.header {
  padding: 5px;
  font-size: 32px !important;
  font-weight: 500;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  color: rgb(51, 82, 128);
}

.sub-header {
  padding: 10px;
  font-size: 18px !important;
  font-weight: 500;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  color: rgb(115, 115, 115);
}

#loginInfoHolder {
  position:absolute;
  display: flex;
  background:white;
  padding: 0 8px;
  text-align: center;
  align-items: center;
}

#loginInfoHolder svg{
  border: 1px solid black;
  line-height: 8px;
  height: 8px;
  width: 8px;
  border-radius: 16px;
  padding: 3px;
  margin-left: 6px;
  font-size: 8px;
}
</style>
